import { BadGatewayError } from './BadGatewayError'

export class ProxyUnavailableError extends BadGatewayError {
	constructor(message: string) {
		super(message)
		this.name = 'ProxyUnavailableError'
	}
}

export function createProxyUnavailableError() {
	const result = new ProxyUnavailableError('Your internet proxy is temporarily unavailable. It will be automatically solved soon. Please, try again later.')
	return result
}
